

// export const BASE_URL = "http://localhost:3050/api";
// export const URL = "http://localhost:3050";


// export const BASE_URL = "https://biometric-staging-backend.caprover-testing.mtechub.com/api";
// export const URL = "https://biometric-staging-backend.caprover-testing.mtechub.com";
// export const BASE_URL = "https://biometric-be-saud.caprover-testing.mtechub.com/api";
export const URL = "https://backend.biometricpro.app";

export const BASE_URL=' https://backend.biometricpro.app/api'
// export const BASE_URL='http://192.168.18.107:4000/api'